var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'home' }}},[_c('v-img',_vm._b({attrs:{"src":_vm.path,"alt":"Koios","width":_vm.width,"height":_vm.height}},'v-img',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }